import get from 'lodash/get';
import { ListGroupDisplayType } from "../../interface/index.js";
import { ImageThemes } from '@ebay-business-components/group-card/dist/interface';
$ const groupCards = get(input, 'groupCards', []);
$ const icon = get(input, 'icon', undefined);
$ const displayType = input.displayType === ListGroupDisplayType.HORIZONTAL ? ListGroupDisplayType.HORIZONTAL : ListGroupDisplayType.VERTICAL;
<if(groupCards.length > 0)>
  <div class=`list-group-cards list-group-cards__${displayType}`>
    <for|card| of=groupCards>
      $ const cardData = card.imageTheme === ImageThemes.ICON && !!icon ? {
        icon,
        ...card,
        theme: card.theme || "DEFAULT"
      } : {
        ...card,
        theme: card.theme || "DEFAULT"
      };
      <group-card ...cardData on-menu-select('emit', 'menu-select', card) on-menu-update('emit', 'menu-update', card) on-click('emit', 'click', card)/>
    </for>
  </div>
</if>